module.exports = __webpack_public_path__ + "static/media/legacy-ea.8e26097f.svg";